import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { TestimonialCard } from './TestimonialCard';
const testimonials = [{
  headlineNode: <>
        After{' '}
        <span className="font-black text-rose-700 underline decoration-rose-200 decoration-4 underline-offset-4" data-id="element-512" data-mp="167cge3nzybt">
          multiple medical specialists failed
        </span>{' '}
        to identify what was wrong, he finally got a Transformation Program with
        us and thanked us for{' '}
        <span className="block pt-2 text-2xl font-black text-teal-700 md:text-3xl" data-id="element-513" data-mp="65trmt31zon9">
          giving him his life back.
        </span>
      </>,
  text: `Ali... Brenden... I can't stress enough how working with this team is guaranteed to provide transformations. They're doing something revolutionary here.

You'll be getting something extremely personalized. You'll be getting the care that you need and the multi-faceted support you need, both on the emotional front, mental front, and medical front.

Working with them is just a fantastic experience. If you're looking for something life-changing, or want to attack diseases that the mainstream says are not really treatable, it will blow your mind. That's what I can guarantee.`,
  name: 'Sean L., Transformation Services Client',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kFsThom7rrs3SjPcRaZ1a1/SeanL.jpg'
}, {
  headlineNode: <>
        After personally hiring many of the most well-known and expensive experts
        in health and wellness, she accomplished{' '}
        <span className="mt-2 block text-2xl font-black text-teal-700 underline decoration-teal-200 decoration-4 underline-offset-4 md:text-3xl" data-id="element-514" data-mp="12b2w5dmvr1ew">
          more in 2 weeks with us than in a whole year with the others.
        </span>
      </>,
  text: `Brenden, all these so-called proficient doctors in our space, and we've accomplished more in 2 weeks than in the past year.

I'm honored, excited, and so grateful I finally found who I have been looking for.`,
  name: 'Shawna C., Peptide Mastery Buyer & Transformation Services Client',
  profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wu3WrEb7TMcpemyocLBB2S/Screenshot_2025-11-10_202634.png'
}];
export function TopTestimonialsSection() {
  return <section className="grain-section w-full border-b border-black/[0.06] bg-white px-6 py-20 md:py-28" data-id="element-515" data-mp="3fxu4aqgt968u">
      <div className="mx-auto max-w-4xl" data-id="element-516" data-mp="3b36m19ceh82p">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16 text-center" data-id="element-517" data-mp="3ozjs7mbhhn1v">
          <span className="inline-flex items-center gap-2 rounded-full border border-teal-200 bg-teal-50 px-4 py-2 text-xs font-black uppercase tracking-[0.18em] text-teal-700" data-id="element-518" data-mp="2n4uz99f53dm">
            <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-519" data-mp="cjq0rwt9iiii" />
            Client Proof
          </span>
          <h2 className="mx-auto mt-6 max-w-3xl font-display text-4xl font-black leading-tight tracking-tight text-ink md:text-6xl" data-id="element-520" data-mp="7ly46phoa87z">
            More Client Transformations{' '}
            <span className="text-teal-600" data-id="element-521" data-mp="v674jz5vkfog">We've Helped Achieve</span>
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-ink-light md:text-xl" data-id="element-522" data-mp="h6o1hkrx7uj0">
            Clear outcomes from clients who came to us after other approaches
            failed to deliver the answers and progress they needed.
          </p>
        </motion.div>

        <div className="space-y-14 md:space-y-16" data-id="element-523" data-mp="c961wkzsmrno">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.name} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} data-id="element-524" data-mp="3un5idbwdez6y" data-mpi={index}>
              <TestimonialCard headlineNode={testimonial.headlineNode} text={testimonial.text} profileImage={testimonial.profileImage} name={testimonial.name} highlight={true} data-id="element-525" data-mp="3pn9ct880yzpa" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}